import { render, staticRenderFns } from "./TempRanking.vue?vue&type=template&id=27863051"
import script from "./TempRanking.vue?vue&type=script&lang=js"
export * from "./TempRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports